import type { ChangeEventHandler } from 'react';
import type { TextareaProps } from '../../../components/Textarea/Textarea';

import Textarea from '../../../components/Textarea/Textarea';

import useYjsField from '../../collaboration/useYjsField';
import { useFieldContext } from '../../form';
import { useFieldErrors } from '../../useFieldErrors';

const TextareaField = ({
  onFocus,
  onBlur,
  disabled,
  ...props
}: TextareaProps) => {
  const field = useFieldContext<string>();
  const errors = useFieldErrors(field.name);

  const yjsField = useYjsField('string');

  const onChange: ChangeEventHandler<HTMLTextAreaElement> = (e) => {
    field.handleChange(e.target.value);
    yjsField.update(e.target.value);
  };

  const onFieldFocus = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    onFocus?.(e);
    yjsField.onFocus();
  };

  const onFieldBlur = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    onBlur?.(e);
    field.handleBlur();
    yjsField.onBlur();
  };

  return (
    <Textarea
      {...props}
      name={field.name}
      value={field.state.value}
      onChange={onChange}
      error={errors}
      onFocus={onFieldFocus}
      onBlur={onFieldBlur}
      disabled={disabled || yjsField.isBeingEdited}
      editors={yjsField.fieldEditors}
    />
  );
};

export default TextareaField;
